export default __webpack_public_path__ + "static/media/file.faa2a74e.svg";